module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/ic_team_member-b7058bc8bcec07d9ea9c0ddcebbf8e75.png";